export default __webpack_public_path__ + "static/media/fi_FI.95d56fd9.svg";